module.exports = fox._r("images/lock.png", __webpack_public_path__ + "images/lock.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/lock.png
// module id = 1074
// module chunks = 4